// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpyLineChartTooltipPositionService {
  repositionTooltip(
    canvasWidth: number,
    tooltipOffsetWidth: number,
    eventX: number,
    eventY: number,
  ): { left: number; top: number } {

    const padding = 15;
    let leftOffset = eventX + padding;
    const tooltipRightPosition = leftOffset + tooltipOffsetWidth + padding;

    if (tooltipRightPosition > canvasWidth) {
      leftOffset = eventX - padding - tooltipOffsetWidth;
    }

    return {left: leftOffset, top: eventY};
  }
}
